import store from "../store-root";
import api from "../../service/api";

const moduleName = "customer";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取经销商列表;
    async getCustomList({ commit }) {
      let result = await api.get("/api/Customer");
      return result.data;
    },
  },
});

export default moduleName;
